import { Button } from 'primereact/button';
import { Editor } from 'primereact/editor';
import { Skeleton } from 'primereact/skeleton';
import { useEffect, useState } from 'react';
import {
    guardaDocumentoSin,
    recuperaDocumentoSin
} from '../../services/Siniestro/SiniestroService';

const EditaDocumento = ({ datosSiniestro, toast, funcSalir }) => {
    //console.log ('DATOS SINIESTRO: ', datosSiniestro)
    const [texto, setTexto] = useState('');
    const [cargaTexto, setCargaTexto] = useState(false);
    const [procesa, setProcesa] = useState(false);

    useEffect(() => {
        const recuperarDocumento = async () => {
            try {
                setCargaTexto(true);
                const datos = await recuperaDocumentoSin(datosSiniestro.siniestroId);
                setTexto(datos.textoDocumento);
            } catch (error) {
                console.error('ERROR: Al recuperar el Documento');
            } finally {
                setCargaTexto(false);
            }
        };
        recuperarDocumento();
    }, [datosSiniestro.siniestroId]);

    const handleGuardaDoc = async () => {
        //console.log('DATO GUARDADO: ', texto);
        if (!texto) {
            toast.current.show({
                severity: 'warn',
                summary: 'Atencion',
                detail: 'Debe llenar el Documento'
            });
            return;
        }
        try {
            setProcesa(true);
            const objDoc = {
                textoDocumento: texto
            };
            const dato = await guardaDocumentoSin(datosSiniestro.siniestroId, objDoc);
            if (dato?.siniestroId) {
                toast.current.show({
                    severity: 'success',
                    summary: 'Exito',
                    detail: 'Se ha registrado el Documento'
                });
            }
        } catch (error) {
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Error al guardar el documento'
            });
            console.error('ERROR: no se ha guardado el documento');
        } finally {
            setProcesa(false);
            funcSalir();
        }
    };

    return (
        <div className="card">
            <div className="formgrid grid p-fluid mb-3">
                <div className="field col-12 md:col-3">
                    <label>Descripcion Evento: </label>
                </div>
                <div className="field col-12 md:col-9">
                    <span className="inline-block w-full bg-gray-100 border border-gray-300 text-gray-600 p-2 rounded-md text-base shadow-inner">
                        {datosSiniestro.descripcion}
                    </span>
                </div>
                <div className="field col-12 md:col-12">
                    {cargaTexto ? (
                        <div>
                            <Skeleton width="100%" height="40px" className="mb-2"></Skeleton>{' '}
                            <Skeleton width="100%" height="320px"></Skeleton>{' '}
                        </div>
                    ) : (
                        <Editor
                            value={texto}
                            onTextChange={(e) => setTexto(e.htmlValue)}
                            style={{ height: '320px' }}
                            readOnly={funcSalir ? false : true}
                            disabled={funcSalir ? false : true}
                        />
                    )}
                </div>
                <div className="field col-12 md:col-9">
                    <label style={{ visibility: 'hidden' }}>Texto oculto</label>
                </div>
                <div className="field col-12 md:col-3">
                    {funcSalir ? (
                        <Button
                            label="Guardar"
                            icon="pi pi-save"
                            onClick={handleGuardaDoc}
                            loading={procesa}
                        />
                    ) : (
                        <label style={{ visibility: 'hidden' }}>Texto oculto</label>
                    )}
                </div>
            </div>
        </div>
    );
};

export default EditaDocumento;
